<template>
    <div class="table_wrap">
        <div class="el-table list-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition el-table__body-wrapper is-scrolling-none">
            <div class="">
                <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;" class="el-table__header">
                    <colgroup>
                        <col width="200">
                        <col width="">
                        <col width="">
                        <col width="120">
                    </colgroup>
                    <thead class="has-gutter">
                    <tr>
                        <th class="is-leaf list-header">
                            <div class="cell">테스트명</div>
                        </th>
                        <th class="is-leaf list-header">
                            <div class="cell">이미지</div>
                        </th>
                        <th class="is-leaf list-header">
                            <div class="cell">이동링크</div>
                        </th>
                        <th class="is-leaf list-header">
                            <div class="cell">옵션</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(level, index) in levelData" :key="`level${index}`" class="el-table__row">
                        <td>
                            <div class="cell text-center">
                                {{level.lt_name}}
                            </div>
                        </td>
                        <td>
                            <div class="cell text-center" @click="changeType(`levelData[${index}]File`)">
                                <el-upload
                                    class="avatar-uploader level-image"
                                    action=""
                                    list-type="picture-card"
                                    :show-file-list="false"
                                    :file-list="level.File"
                                    :auto-upload="false"
                                    :on-change="onlyOnePhotoChange"
                                >
                                    <img v-if="hasImage(level)" :src="returnImageUrl(level)" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    <div slot="tip" class="el-upload__tip c_danger">jpg/png 종류의 파일과 10MB 이하의 파일만 가능합니다.</div>
                                </el-upload>
                            </div>
                        </td>
                        <td>
                            <div class="cell text-center">
                                <el-input v-model="level.lt_url"></el-input>
                            </div>
                        </td>
                        <td>
                            <div class="cell text-center">
                                <div class="row-info">
                                    <el-button @click="runSave(level)">
                                        저장
                                    </el-button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="btn_wrap pa10 text_right">
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";
import elFileMixins from "@/mixins/elFileMixins";

export default {
    name: "LevelTestComponent",
    mixins: [elFileMixins, imageOption],
    components: {},
    inject: ['changeLoading'],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            levelData: [],
            keyName: 'b_idx',
            DeleteClass: null,
        }
    },
    created() {
        this.getList()
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getList() {
            this.$api.$level.getLevelTest().then(res => res.Data.Result).then(res => {
                if(!util.isEmpty(res.List)) {
                    this.levelData = res.List;
                }
            })
        },
        hasImage(level) {
            return !util.isEmpty(level.File)
        },
        returnImageUrl(level) {
            if(!util.isEmpty(level.File[0].url)) {
                return level.File[0].url
            }
            return `${level.File[0].org_url}?${this.setImageOptions(296, 296, 'webp')}`;
        },



        onlyOnePhotoChange(file, fileList) {

            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');
            if (file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
                fileList.pop();
            } else if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {

                let dataFile = this.$_.get(this, `${this.fileType}`)
                if (this.fileType === '' || dataFile === undefined) {
                    if (this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                        file.a_idx = this.files[0].a_idx;
                    }
                    this.files[0] = file;
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange('files', this.files);
                    }
                } else {
                    let dataFile = this.$_.get(this, `${this.fileType}`)
                    if (dataFile.length > 0 && dataFile[0].hasOwnProperty('a_idx') && dataFile[0].a_idx != null) {
                        file.a_idx = dataFile[0].a_idx;
                    }
                    this.$_.set(this, `${this.fileType}`, [file]);
                    this.$forceUpdate();
                    if (this.parentChange) {
                        this.parentChange(this.fileType, this[this.fileType]);
                    }
                }
            }
        },
        runSave(banner) {
            let checkData = this.checkData(banner);
            if(checkData != true) {
                this.errorAlert(checkData)
                return false;
            }

            this.updateLevelTest(banner);
            return true;
        },
        checkData(level) {
            if(util.isEmpty(level.File) || util.isEmpty(level.lt_url)) {
                return '모든 데이터를 다 입력해주세요.';
            }
            var expUrl = /^http[s]?\:\/\//i;
            if(!expUrl.test(level.lt_url)) {
                return '이동링크는 http, https 가 존재하는 url 형식으로 입력해주세요.'
            }
            return true;
        },
        updateLevelTest(level) {

            let params = {
                lt_idx: level.lt_idx,
                lt_url: level.lt_url,
            }
            try {
                this.changeLoading(true);
                this.$api.$level.updateLevelTest(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type === 1) {
                        this.uploadFiles(level.File, 'level', params.lt_idx).then(res => {
                            this.saveSuccess();
                        })
                    }else{
                        this.errorAlert('저장에 실패하였습니다.');
                    }
                })
            }catch (e) {
                this.changeLoading(false)
                console.log(e);
            }
        },
        saveSuccess() {
            this.changeLoading(false);
            this.levelData = [];
            this.getList();
            this.createAlert({
                content: '저장되었습니다.',
            })
        },
        saveFail() {
            this.changeLoading(false)
            this.errorAlert('저장에 실패하였습니다.')
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
